import axios from "axios";

import ConnUrls from '../Connections/ConnectURL'
import { placeParams } from '../ContextApi/cityContext';

// placeParams - המקום והעיר של הלקוח: השרת מסנן ומסדר את רשימות העסקים לפיהם (DTechComp/placeRelevance.js)


const getRestsUrls = async () => {

    let dFromF = await axios.get(ConnUrls.ApiUrl + "rest/restsUrls");

    return (dFromF.data);

}
const getRestById = async (id) => {
    let dFromF = await axios.get(ConnUrls.ApiUrl + "rest/web/" + id);
    return (dFromF.data);
}

const getMainRestsByIds = async (idsList) => {
    let dFromF = await axios.put(ConnUrls.ApiUrl + "rest/web/byids", idsList);
    return (dFromF.data);
}

const getMainRests = async (obj) => {
    let dFromF = await axios.put(ConnUrls.ApiUrl + "rest/web/mainrests", { ...(obj || {}), ...placeParams() });
    return (dFromF.data);
}

const getTableReservsList = async (obj) => {
    let dFromF = await axios.get(ConnUrls.ApiUrl + "rest/tableReservs", { params: placeParams() });
    return (dFromF.data);
}

const getRestNowOpen = async (obj) => {
    let dFromF = await axios.put(ConnUrls.ApiUrl + "rest/nop", { ...(obj || {}), ...placeParams() });
    return (dFromF.data);
}

const getSerchResault = async (txtSrch) => {
    let dFromF = await axios.get(ConnUrls.ApiUrl + "rest/txtSrch/" + txtSrch, { params: placeParams() });
    return (dFromF.data);
}


const getallBuisSmallLst = async (txtSrch) => {
    let dFromF = await axios.get(ConnUrls.ApiUrl + "rest/getallBuisSmallLst/" + txtSrch, { params: placeParams() });
    return (dFromF.data);
}

const logSearchTerm = async (term) => {
    let dFromF = await axios.post(ConnUrls.ApiUrl + "rest/logSearchTerm", { term });
    return (dFromF.data);
}

const getSupermarketProducts = async (restId, startCategoryIndex, startSubCategoryIndex, offset, limit) => {
    let dFromF = await axios.post(ConnUrls.ApiUrl + "rest/supermarket/products", {
        restId,
        startCategoryIndex,
        startSubCategoryIndex,
        offset,
        limit
    });
    return (dFromF.data);
}

export default {
    getallBuisSmallLst,
    getMainRests,
    getTableReservsList,
    getMainRestsByIds,
    getRestNowOpen,
    getRestById,
    getSerchResault,
    getRestsUrls,
    getSupermarketProducts,
    logSearchTerm
};